/* @flow */
import PropTypes from "prop-types";

import React from "react";
import { isEmpty } from "shared/src/utils/util";

type Props = {
    k: string;
    descriptionIsText: boolean | undefined | null;
    type: string;
};

/**
 * Sets the document title when it is mounted.
 */
class DocumentMetaTag extends React.Component<Props> {
    head = document.getElementsByTagName("head")[0];

    static propTypes = {
        k: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired
    };

    static contextTypes = {
        intl: PropTypes.object
    };

    componentDidMount() {
        this.removeMetaTag();
        this.setMetaTag();
    }

    componentDidUpdate() {
        this.removeMetaTag();
        this.setMetaTag();
    }

    componentWillUnmount() {
        this.removeMetaTag();
    }

    removeMetaTag() {
        if (this.head) {
            const metaTags = document.getElementsByTagName("meta");
            Array.from(metaTags)
                .filter((tag) => tag.name === this.props.type)
                .forEach((tag) => this.head.removeChild(tag));
        } else {
            console.warn("No head found to add meta Tag");
        }
    }

    setMetaTag() {
        let kString;
        const { k, type, ...args } = this.props;
        if (Array.isArray(k)) {
            kString = k.join(".") || "";
        } else {
            kString = k || "";
        }
        let text = kString;
        if (!this.props.descriptionIsText) {
            try {
                if (!isEmpty(args)) {
                    text = this.context.intl.formatMessage({ id: kString }, args);
                } else {
                    text = this.context.intl.formatMessage({ id: kString });
                }
            } catch (e) {
                console.warn("Message key not found", kString, e);
            }
        }
        const tag = document.createElement("meta");
        tag.name = type;
        tag.content = text;
        if (this.head) {
            this.head.appendChild(tag);
        } else {
            console.warn("No head found to add meta Tag");
        }
    }

    render() {
        return <span />;
    }
}

export default DocumentMetaTag;
